module.exports = __webpack_public_path__ + "static/img/404.e9d173b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/404.png
// module id = bhgG
// module chunks = 17